import { render } from "./inventoryheader.vue?vue&type=template&id=6f119ea1"
import script from "./inventoryheader.vue?vue&type=script&lang=js"
export * from "./inventoryheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__